const allowedPaths = ["/projects", "/contractor", "/accept-invitation", "/chat"] as const;

export function safeReturnTo(value: string | null, fallback = "/projects"): string {
  if (!value?.startsWith("/") || value.startsWith("//") || value.includes("\\")) return fallback;
  try {
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin) return fallback;
    return allowedPaths.some((path) => url.pathname === path || url.pathname.startsWith(`${path}/`))
      ? `${url.pathname}${url.search}${url.hash}`
      : fallback;
  } catch {
    return fallback;
  }
}
